import {Button, Dialog, Icon, Loading} from '@startlibs/components';
import React, { useEffect, useState } from 'react'
import {CASE_CLOSED} from '../enums/CaseState';
import {Header} from '../components/Header'
import {Card, HeaderButtons, PageContainer} from '../components/PageLayout';
import {PurviewFooter} from '../components/PurviewFooter'
import {SuccessBox} from '../components/InfoBox';
import {getJwt} from '../hooks/useJwt'
import {useShareDialog} from '../hooks/useShareDialog'
import {lazyProviderInfo} from '../components/WithProvider'
import {PdfReportFrame, PdfReportFrameWrapper} from '../request/components/PdfReportFrame'
import {useIframeIsLoading} from '../admin/steps/hooks/useIframeIsLoading'
import {PreviewForReport} from '../request/reviewedRequest/PreviewForReport'
import {Load} from '../hooks/useSuspense'
import { PatientFeedback } from '../components/PatientFeedback';
import styled from 'styled-components';
import { jwtGetFetcher } from '../utils/authFetch';
import { AssignmentStatusBox } from '../admin/steps/expertReview/ExpertReviewList';
import { isReadOnlyShare } from './utils/caseRequestUtils';

const PageTitle = styled.h1 `
  font-size: 21px;
  margin-bottom: 1rem;
  flex-shrink; 0;
`

export const PatientReport = ({caseRequest,feedbackPopup}) => {

  const providerInfo = lazyProviderInfo.read()

  const readOnlyShare = isReadOnlyShare(caseRequest)
  const canAccessCaseOverview = providerInfo?.patientAccessFunctions?.caseOverview && !readOnlyShare

  const casePreferredLanguage = caseRequest?.caseInfo?.preferredLanguage || "en-US"
  const casePreferredLanguageExistInOptions = providerInfo?.preferredLanguage?.options?.find(o => o.id == casePreferredLanguage)
  const preferredLanguage = casePreferredLanguageExistInOptions ? casePreferredLanguage : providerInfo?.preferredLanguage?.defaultLanguage ? providerInfo?.preferredLanguage?.defaultLanguage : casePreferredLanguage

  const [hasFeedback, setHasFeedback] = useState(false)
  const [justSentFeedback, setJustSentFeedback] = useState(false)
  const isSharedRO = caseRequest.readOnlyAcessEmail != null || caseRequest.requestCode.includes('RO-')
  
  useEffect(() => {
    jwtGetFetcher(getJwt())(`/api/feedback`)
      .then((_response) => {
        setHasFeedback(true)
      })
      .catch((_error) => {
        setHasFeedback(false)
      })
  },[])

  const iframeIsLoading = useIframeIsLoading(caseRequest.report?.useCustomReport)

  const [openShareDialog, shareDialog] = useShareDialog(caseRequest)
  const caseCompletedWithoutReport = caseRequest.state === CASE_CLOSED && !caseRequest.report?.customReport && !caseRequest.report?.useCustomReport && !caseRequest.report
  
  return <> <PageContainer withPrint={true}>
    <Header title="Expert View report" noPrint>
      {caseRequest.state === CASE_CLOSED && <SuccessBox>
        <Icon icon="check" /><span>Expert View complete.</span>
      </SuccessBox>}
    </Header>
    {caseRequest.state === CASE_CLOSED && !caseCompletedWithoutReport &&
      <HeaderButtons noPrint>
        <div className="left-wrapper">
          {canAccessCaseOverview && <Button.Link to="/patient/overview">Go to overview</Button.Link>}
        </div>
        <div className="right-wrapper">
          <Button.a href={`/api/report/download?token=${getJwt()}&requestId=${caseRequest.requestId}`} icon="download">Save PDF</Button.a>
          <Button.a target="_blank" href={`/api/report/preview?token=${getJwt()}&requestId=${caseRequest.requestId}`} icon="print">Print</Button.a>
          {!isSharedRO && <Button highlight onClick={openShareDialog} icon="send">Share</Button>}
        </div>
      </HeaderButtons>
    }
    {
      caseCompletedWithoutReport 
        ? <AssignmentStatusBox reviewed={caseRequest.state === CASE_CLOSED}>
            <div className="waitingBoxContent">
              <Icon icon={'check'}/>
              <h4>
                {'This case is already completed.'}
              </h4>
              <p>The case has been marked as completed, but no report was generated.</p>
            </div>
          </AssignmentStatusBox> 
        : caseRequest.report?.useCustomReport
          ? <PdfReportFrameWrapper>
            <PdfReportFrame
              pdfReport
              onLoad={iframeIsLoading.close}
              src={`/api/report/preview?token=${getJwt()}&requestId=${caseRequest.requestId}&refreshPdf=${caseRequest.pdfKey}#toolbar=0&navpanes=0`}
            />
            {iframeIsLoading.isOpen && <Loading absolute/>}
          </PdfReportFrameWrapper>
          : <Load value={lazyProviderInfo}>{providerInfo =>
            <PreviewForReport
              report={caseRequest.report}
              preferredLanguage={preferredLanguage}
              info={providerInfo}
            />
          }</Load>
    }
    {caseRequest.state === CASE_CLOSED &&
      <HeaderButtons noPrint>
        <div className="left-wrapper">
          {/* <Button onClick={() => navigate(`/patient/overview`)}>Go to overview</Button> */}
          {canAccessCaseOverview && <Button.Link to="/patient/overview">Go to overview</Button.Link>}
        </div>
        {!caseCompletedWithoutReport && <div className="right-wrapper">
          <Button.a href={`/api/report/download?token=${getJwt()}&requestId=${caseRequest.requestId}`} icon="download">Save PDF</Button.a>
          <Button.a target="_blank" href={`/api/report/preview?token=${getJwt()}&requestId=${caseRequest.requestId}`} icon="print">Print</Button.a>
          {!isSharedRO && <Button highlight onClick={openShareDialog} icon="send">Share</Button>}
        </div>}
      </HeaderButtons>
    }
    {
      shareDialog
    }
    {!hasFeedback && !justSentFeedback && caseRequest.requestId && <Card css="margin-top: 5rem" noPrint>
      <PageTitle>Share feedback</PageTitle>
      <PatientFeedback caseRequest={caseRequest} setJustSentFeedback={setJustSentFeedback}/>
    </Card>}
    {justSentFeedback && <Card css="margin-top: 5rem">
      <h3 css="margin-bottom:0;text-align:center;">Thank you for your feedback!</h3>
    </Card>}
    {feedbackPopup.isOpen && <Dialog title="Share feedback" closeDialog={feedbackPopup.close}>
      <PatientFeedback caseRequest={caseRequest} feedbackPopup={feedbackPopup} isPopup />
      </Dialog>
    }
    </PageContainer>
    <PurviewFooter/>
  </>
}
